import React from 'react';
import { connect } from 'react-redux';
import { ShapeEntity, getSelectedSection } from '@/helpers';
import { updateSelectedSectionsProps } from '@/actions';
import ShapesAndVectors from './ShapesAndVectors';

const ShapesAndVectorsContainer = props => {
  const { updateSelectedSectionsProps, ...rest } = props;

  const handleShapeSelection = shapeName => {
    updateSelectedSectionsProps({ shape: ShapeEntity.getEmptyShapeProps(shapeName) });
  };

  const handleDragStart = shapeName => {
    ShapeEntity.setShape(shapeName);
  };

  return <ShapesAndVectors {...rest} handleShapeSelection={handleShapeSelection} handleDragStart={handleDragStart} />;
};

const mapStateToProps = state => {
  const { sectionsSelection, pages } = state.core;
  const selectedSection = getSelectedSection({ sectionsSelection, pages });

  return {
    selectedSection,
  };
};

const mapDispatchToProps = {
  updateSelectedSectionsProps,
};

export default connect(mapStateToProps, mapDispatchToProps)(ShapesAndVectorsContainer);
